import {
  IconButton,
  IconButtonProps,
  ComponentWithAs,
} from '@wegroup/design-system';
import React from 'react';

const ToolbarIconButton: ComponentWithAs<'button', IconButtonProps> = ({
  ...props
}) => {
  return (
    <IconButton
      w="10"
      h="10"
      bg="secondary.600"
      _hover={{ bg: 'secondary.500' }}
      {...props}
    />
  );
};

export default ToolbarIconButton;
